import React from 'react';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
interface ResidentialSolutionsProps {
  onNavigate: (page: PageType) => void;
}
const services = [{
  id: 'smart-house',
  label: 'smart house'
}, {
  id: 'high-end-audio',
  label: 'high end audio'
}, {
  id: 'privatni-kinosal',
  label: 'privátní kinosál'
}, {
  id: 'fve',
  label: 'FVE'
}];
export function ResidentialSolutions() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <section id="rezidentni" className="w-full bg-white py-12" data-id="element-198">
      <div className="max-w-6xl mx-auto px-6" data-id="element-199">
        {/* Top Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 items-start mb-24" data-id="element-200">
          {/* Left Column - Services List */}
          <div className="flex flex-col items-end text-right" data-id="element-201">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide mb-2" data-id="element-202">
              REZIDENČNÍ ŘEŠENÍ
            </h2>
            <p className="text-[#999] font-light mb-8" data-id="element-203">
              Technologie pro váš domov
            </p>
            <ul className="space-y-2" data-id="element-204">
              {services.map(service => <li key={service.id} data-id="element-205">
                  <a href={`#${service.id}`} onClick={e => handleScroll(e, service.id)} className="flex items-center justify-end gap-3 text-[#707070] hover:text-[#404040] transition-colors group py-1" data-id="element-206">
                    <span className="text-base" data-id="element-207">{service.label}</span>
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 group-hover:opacity-100 transition-opacity scale-x-[-1]" data-id="element-208" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Column - SVG Illustration */}
          <div className="w-full flex items-center justify-center py-8" data-id="element-209">
            <img src="https://cdn.magicpatterns.com/uploads/5S9rCkney38jHHBLoQTQXv/rezidence.svg" alt="Rezidenční řešení" className="h-52 md:h-[17rem] w-auto object-contain opacity-[0.44]" data-id="element-210" />
          </div>
        </div>

        {/* Detailed Sections */}
        <div className="space-y-16 lg:pl-[100px]" data-id="element-211">
          {/* 1. smart house */}
          <div id="smart-house" className="border-t border-gray-200 pt-16" data-id="element-212">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-213">
              smart house
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-214">
              <p data-id="element-215">
                Chytrý dům. Může to být zavádějící pojem, ale je to zažitý
                termín pro dům, který má z elektro více než kabely ke světlům a
                na nich vypínače. Naše projekty jsou především větší a
                luxusnější domy a byty. A v těch bývá větší počet světelných
                okruhů, často stmívaných, stínění, klimatizace, zabezpečovací
                systém, intercom, vzduchotechnika, bazénová technologie a řada
                dalších systémů.
              </p>
              <p data-id="element-216">
                Tzv. chytrý dům znamená, že je ovládání všech těchto systémů
                sjednocené. Uživatel má k dispozici snadné a přehledné ovládání.
                Je pak na něm, jak moc si chce se systémy „hrát“. Někdo chce
                vědět o všem v domě, mít možnost nastavit každou drobnost. Jiný
                zase nechce nic řešit, jen ovládat to nejnutnější. A nemusí být
                na každém kroku znát, že je dům tak moderní.
              </p>
              <p data-id="element-217">
                Máme pochopení a řešení pro obojí. A právě proto, aby byl dům
                podle vás, je potřeba řešit jeho technologie a jejich ovládání
                už při přípravě projektu. Pokud se vše správně pojme, budete s
                výsledkem spokojeni.
              </p>
            </div>
          </div>

          {/* 2. high end audio */}
          <div id="high-end-audio" className="border-t border-gray-200 pt-16" data-id="element-218">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-219">
              high end audio
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-220">
              <p data-id="element-221">
                Máte rádi kvalitní hudbu, a chcete i kvalitní reprodukci hudby,
                skutečný high end? Ozvěte se, a my vás provedeme možnostmi
                řešení, které bude pro vás to pravé. Ať už to bude vaše
                pracovna, obývací pokoj, či poslechová místnost. Doručíme
                kvalitní zvuk tam, kde to bude potřeba.
              </p>
            </div>
          </div>

          {/* 3. privátní kinosál */}
          <div id="privatni-kinosal" className="border-t border-gray-200 pt-16" data-id="element-222">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-223">
              privátní kinosál
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-224">
              <p data-id="element-225">
                Nenuťte se ke skromnosti. Pořiďte si vlastní kinosál, ve vašem
                domě. Stačí jen pár kroků, a jste v jiném světě. S komfortem,
                který nenabídne běžné domácí kino ve vašem obývacím pokoji, ani
                ten nejlepší multikino. Perfektně sladěný zvuk a velký obraz,
                začátek představení právě v ten okamžik, který si vy zvolíte,
                luxusní a pohodlná křesla v první řadě. Vše zabalené do designu
                na míru, přesně podle vašeho vkusu. Domácí kinosál je
                nekompromisním řešením domácí zábavy. Dejte nám prostor, a my
                vám dáme luxus. Svěřte se do naší péče, postaráme se o vás a
                splníme váš sen. Do detailu.
              </p>
            </div>
          </div>

          {/* 4. FVE */}
          <div id="fve" className="border-t border-gray-200 pt-16" data-id="element-226">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-227">
              FVE
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-228">
              <p data-id="element-229">
                Realizujeme kompletní fotovoltaické elektrárny do velikosti XY
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}